/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { WithRouter } from '@/components/WithRouter'
import { useSelector, useDispatch } from 'react-redux'
import { Form, Input, Button, Card, message } from 'antd'
import { getBrowserType } from '@/redux/app/appSlice'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { checkToken, saveTokenWithTimestamp } from '@/utils/helpers'
import Session from '@/utils/session'
import axios from 'axios'
import BasicConfig from '@/config/basic'

// 创建一个不带 baseURL 的 axios 实例用于登录请求（避免被 /api 前缀影响）
// 明确设置 baseURL 为空字符串，确保不受 axios.defaults.baseURL 影响
const loginAxios = axios.create({
  baseURL: '', // 明确设置为空，避免继承 axios.defaults.baseURL
  timeout: 15000
})

// 添加请求拦截器，确保完整 URL 不被错误拼接
loginAxios.interceptors.request.use(
  config => {
    // 如果 url 是完整 URL（以 http:// 或 https:// 开头），确保 baseURL 不会影响它
    if (/^https?:\/\//.test(config.url)) {
      // 临时移除 baseURL，确保完整 URL 直接使用
      config.baseURL = undefined
    }
    console.log('loginAxios', config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
import { store } from '@/redux/store'
import { appLogin } from '@/redux/app/appSlice'
import { bootstrapPermissionCodes } from '@/utils/bootstrapPermissionCodes'

import './Login.less'

const LoginPage = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const { browserType } = useSelector(state => state.app)

  useEffect(() => {
    const { location: { origin } } = window
    const getCookie = Session.readHostIk()
    const checkTokenResult = checkToken(getCookie)
    if (checkTokenResult) {
      // return (window.location.href = origin)
    }
    // 钉钉环境直接登陆
    if (browserType?.environment === 'dingtalk') {
      const dtRedirect = 'http://sysapi.duobaby.net:8098'
      // window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoamoyesowuczkdrnx0&response_type=code&scope=snsapi_auth&state=${origin}&redirect_uri=${dtRedirect}`
      return
    }
  }, [browserType])

  // 手机号验证规则
  const validatePhone = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('请输入手机号码'))
    }
    const phoneReg = /^1[3-9]\d{9}$/
    if (!phoneReg.test(value)) {
      return Promise.reject(new Error('请输入正确的手机号码'))
    }
    return Promise.resolve()
  }

  // 处理登录提交
  const handleLogin = async (values) => {
    const { account, password } = values
    
    setLoading(true)
    try {
      // 使用登录接口
      // 使用 loginAxios 避免被 axios.defaults.baseURL 影响
      const formData = new URLSearchParams()
      formData.append('account', account)
      formData.append('password', password)
      
      // 直接使用 BasicConfig.loginUrl（已根据环境返回相对路径或完整 URL）
      const { origin, pathname } = window.location
      const fallbackUrl = `${origin}${pathname}`
      // 构建登录 URL（包含 fallbackUrl）
      let loginUrl = BasicConfig.loginUrl
      console.log('BasicConfigBasicConfig:', loginUrl)
      console.log('BasicConfigBasicConfig:fallbackUrl', fallbackUrl)
      // 如果 loginUrl 是完整 URL，添加 fallbackUrl 参数
      if (/^https?:\/\//.test(loginUrl)) {
        const encodedFallbackUrl = fallbackUrl
          .replace('?', 'AAA')
          .replace('#', 'BBB')
          .replace(/&/g, 'CCC')
        const separator = loginUrl.includes('?') ? '&' : '?'
        loginUrl = `${loginUrl}${separator}fallbackUrl=${encodedFallbackUrl}`
      } else {
        // 相对路径：添加 fallbackUrl 参数
        const encodedFallbackUrl = fallbackUrl
          .replace('?', 'AAA')
          .replace('#', 'BBB')
          .replace(/&/g, 'CCC')
        loginUrl = `${loginUrl}?fallbackUrl=${encodedFallbackUrl}`
      }
      
      // 在开发环境或测试环境中，如果 loginUrl 是完整 URL，转换为相对路径
      // 如果 loginUrl 包含 IP 地址（如 120.24.30.49），也强制转换为相对路径，避免 CORS 问题
      const isIpAddress = /^https?:\/\/(\d{1,3}\.){3}\d{1,3}/.test(loginUrl)
      if ((process.env.NODE_ENV === 'development' || process.env.BUILD_ENV === 'test' || isIpAddress) && /^https?:\/\//.test(loginUrl)) {
        try {
          const url = new URL(loginUrl)
          loginUrl = url.pathname + (url.search || '')
        } catch (e) {
          // 如果解析失败，尝试手动提取
          const match = loginUrl.match(/https?:\/\/[^\/]+(\/.*)/)
          if (match) {
            loginUrl = match[1]
          } else {
            // 如果无法提取，使用默认路径
            loginUrl = '/api.php/Login/externalLogin'
            // loginUrl = '/tapi/monitorApi.php/Login/monitorLogin'
          }
        }
      }
      
      // 如果 loginUrl 是完整 URL，确保 loginAxios 的 baseURL 不会影响它
      // 如果 loginUrl 是完整 URL，直接使用它；如果是相对路径，使用当前域名
      
      const response = await loginAxios.post(loginUrl, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      // 检查响应头中是否有 token（可能在 Set-Cookie 或其他自定义头中）
      const authHeader = response.headers['authorization'] || response.headers['x-token'] || response.headers['token']
      
      // 尝试从响应头获取 token
      let jwt = null
      if (authHeader) {
        jwt = authHeader.startsWith('Bearer ') ? authHeader.replace('Bearer ', '') : authHeader
      }
      
      // 处理不同的响应格式
      let userInfo = {}
      let loginSuccess = false
      
      // 情况1: 返回数字 1 或字符串 "1" 或 "int(1)"（表示成功）
      const responseData = response.data
      const isSuccess = responseData === 1 || 
                       responseData === '1' || 
                       responseData === 'int(1)' ||
                       (typeof responseData === 'string' && responseData.trim() === '1') ||
                       (typeof responseData === 'string' && responseData.includes('int(1)'))
      
      if (isSuccess) {
        loginSuccess = true
        // 如果响应头有 token，使用响应头的 token
        if (!jwt) {
          // 尝试从响应数据中获取 token
          jwt = response.data?.token || response.data?.jwt
        }
      }
      // 情况2: 标准 JSON 响应
      else if (response.data && typeof response.data === 'object') {
        // 处理后端返回的格式: {"errcode":1,"errinfo":"登录成功","data":{"token":"...",...}}
        const errcode = response.data.errcode
        const errinfo = response.data.errinfo
        const data = response.data.data
        
        // 检查是否成功（errcode === 1 表示成功）
        if (errcode === 1 || response.data.code === 0 || response.data.code === 1 || response.data.status === 'success') {
          loginSuccess = true
          jwt = jwt || data?.token || data?.jwt || response.data.token || response.data.jwt
          userInfo = data || response.data || {}
        } else {
          // 登录失败
          message.error(errinfo || response.data?.message || response.data?.msg || '登录失败，请检查账号密码')
          setLoading(false)
          return
        }
      } else {
        // 其他情况
        message.error('登录失败，请检查账号密码')
        setLoading(false)
        return
      }
      
      // 登录成功，保存信息并跳转
      if (loginSuccess) {
        if (!jwt) {
          message.error('登录失败，未获取到 token')
          setLoading(false)
          return
        }

        // ========== 步骤1: 保存登录 token 和用户信息 ==========
          // 保存 token 及其创建时间（用于 7 天有效期验证）
          saveTokenWithTimestamp(jwt)
          
          Session.setIkCookie(jwt)
          
          // 保存用户信息到 redux
          store.dispatch(appLogin({ token: jwt, user: userInfo }))
          
          message.success('登录成功')
          setLoading(false)
          
          // 阶段 B：javaToken → 权限码，再跳转（失败不阻塞，由 App/Client 补拉）
          await bootstrapPermissionCodes(store)
          const { origin } = window.location
          window.location.href = `${origin}/client`
          return
      }
    } catch (error) {
      // 500 错误通常是服务器内部错误，显示详细错误信息
      if (error.response?.status === 500) {
        const errorMsg = error.response?.data?.message || 
                        error.response?.data?.msg || 
                        error.response?.data?.error ||
                        (typeof error.response?.data === 'string' ? error.response.data : '服务器内部错误')
        message.error(`登录失败: ${errorMsg}`)
        setLoading(false)
      }
      // 如果API调用失败
      else if (error.response?.status === 404 || error.code === 'ERR_NETWORK') {
        message.error('网络错误，请检查网络连接')
        setLoading(false)
      } else {
        message.error(error.response?.data?.message || error.response?.data?.msg || '登录失败，请稍后重试')
        setLoading(false)
      }
    }
  }

  const handleLogin2 = async (values) => {
    const { account, password } = values
    setLoading(true)
    try {
      // 构建表单数据
      const formData = new URLSearchParams()
      formData.append('account', account)
      formData.append('password', password)
      
      // 直接使用 BasicConfig.loginUrl，不需要判断
      const loginUrl = BasicConfig.loginUrl
      
      // 发送登录请求
      const response = await loginAxios.post(loginUrl, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      
      // 从响应中提取 token
      let jwt = null
      
      // 1. 优先从响应头获取 token
      const authHeader = response.headers['authorization'] || 
                        response.headers['x-token'] || 
                        response.headers['token']
      if (authHeader) {
        jwt = authHeader.startsWith('Bearer ') ? authHeader.replace('Bearer ', '') : authHeader
      }
      
      // 2. 从响应数据中获取 token
      const responseData = response.data
      if (!jwt) {
        if (typeof responseData === 'object' && responseData !== null) {
          jwt = responseData.data?.token || 
                responseData.data?.jwt || 
                responseData.token || 
                responseData.jwt
        }
      }
      
      // 3. 检查登录是否成功
      const isSuccess = responseData === 1 || 
                       responseData === '1' || 
                       responseData === 'int(1)' ||
                       (typeof responseData === 'string' && responseData.trim() === '1') ||
                       (typeof responseData === 'string' && responseData.includes('int(1)')) ||
                       (responseData?.errcode === 1) ||
                       (responseData?.code === 0) ||
                       (responseData?.code === 1) ||
                       (responseData?.status === 'success')
      
      if (!isSuccess) {
        const errorMsg = responseData?.errinfo || 
                        responseData?.message || 
                        responseData?.msg || 
                        '登录失败，请检查账号密码'
        message.error(errorMsg)
        setLoading(false)
        return
      }
      
      // 4. 验证 token 是否存在
      if (!jwt) {
        message.error('登录失败，未获取到 token')
        setLoading(false)
        return
      }
      
      // 5. 保存 token 和用户信息
      // 保存 token 及其创建时间（用于 7 天有效期验证）
      saveTokenWithTimestamp(jwt)
      
      Session.setIkCookie(jwt)
      
      // 保存用户信息到 redux
      const userInfo = responseData?.data || responseData || {}
      store.dispatch(appLogin({ token: jwt, user: userInfo }))
      
      message.success('登录成功')
      setLoading(false)
      
      await bootstrapPermissionCodes(store)
      const { origin } = window.location
      window.location.href = `${origin}/client`
      
    } catch (error) {
      console.error('登录失败:', error)
      
      // 处理错误响应
      if (error.response?.status === 500) {
        const errorMsg = error.response?.data?.message || 
                        error.response?.data?.msg || 
                        error.response?.data?.error ||
                        (typeof error.response?.data === 'string' ? error.response.data : '服务器内部错误')
        message.error(`登录失败: ${errorMsg}`)
      } else if (error.response?.status === 404 || error.code === 'ERR_NETWORK') {
        message.error('网络错误，请检查网络连接')
      } else {
        message.error(error.response?.data?.message || 
                     error.response?.data?.msg || 
                     '登录失败，请稍后重试')
      }
      
      setLoading(false)
    }
  }
  
  return (
    <div className="login-page">
      <Card
        title="欢迎进入多宝宝内部系统"
        bordered={null}
        className="login-page-card"
      >
        <Form
          form={form}
          name="login"
          onFinish={handleLogin2}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            name="account"
            label="手机号码"
            rules={[
              { required: true, message: '请输入手机号码' },
              { validator: validatePhone }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="请输入手机号码"
              size="large"
              maxLength={11}
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码长度至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入密码"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default WithRouter(LoginPage)
